// src/components/ads-admin/Chip.js
import React from "react";

export default function Chip({ tone = "neutral", children }) {
  const map = {
    neutral: { bg: "#f3f4f6", fg: "#374151", bd: "#e5e7eb" },
    success: { bg: "#ecfdf5", fg: "#065f46", bd: "#a7f3d0" },
    warn: { bg: "#fffbeb", fg: "#92400e", bd: "#fde68a" },
    error: { bg: "#fef2f2", fg: "#991b1b", bd: "#fecaca" },
    info: { bg: "#eff6ff", fg: "#1e40af", bd: "#bfdbfe" },
  };
  const c = map[tone] || map.neutral;

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        padding: "4px 10px",
        borderRadius: 999,
        fontSize: 12,
        fontWeight: 800,
        border: `1px solid ${c.bd}`,
        background: c.bg,
        color: c.fg,
        whiteSpace: "nowrap",
        lineHeight: 1,
      }}
    >
      {children}
    </span>
  );
}